var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserIconLogin = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 81,
  height: 81,
  fill: "none",
  viewBox: "0 0 81 81",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 40.5,
  cy: 33.75,
  r: 10.125,
  fill: "#0F8491",
  fillOpacity: 0.1,
  stroke: "#0F8491",
  strokeLinecap: "round",
  strokeWidth: 3.375
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.5,
  cy: 40.5,
  r: 30.375,
  stroke: "#0F8491",
  strokeWidth: 3.375
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F8491",
  strokeLinecap: "round",
  strokeWidth: 3.375,
  d: "M60.75 63.132c-1.194-3.588-3.826-6.758-7.488-9.02-3.661-2.261-8.147-3.487-12.762-3.487s-9.101 1.226-12.762 3.487c-3.662 2.262-6.294 5.432-7.488 9.02"
})));
export { SvgUserIconLogin as ReactComponent };
export default __webpack_public_path__ + "assets/images/User_Icon_Login.svg";